// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__24R56","author":"Table_author__xQqMc","authorImage":"Table_authorImage__1KQrR","unreadRow":"Table_unreadRow__XN9_N"};